const STORAGE_KEY = "userAddresses";
const SELECTED_KEY = "selectedAddressId";

export const loadAddresses = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch {
    return [];
  }
};

export const saveAddresses = (addresses) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(addresses));
  return addresses;
};

export const getSelectedAddressId = () => localStorage.getItem(SELECTED_KEY);

export const setSelectedAddressId = (id) => {
  if (id === null || id === undefined) {
    localStorage.removeItem(SELECTED_KEY);
    return null;
  }

  localStorage.setItem(SELECTED_KEY, String(id));
  return id;
};

export const getSelectedAddress = () => {
  const selectedId = getSelectedAddressId();
  if (!selectedId) {
    return null;
  }

  return loadAddresses().find((address) => String(address.id) === String(selectedId)) || null;
};
